import { IOption } from '@core-web/types';

export enum EventTypes {
  SET_CONFIGURATION = 'SET_CONFIGURATION',
}

/**
 * THe VERIFIED event payload
 */
export interface IConfiguration {
  staticMenu: IOption;
  environment: IOption;
}

/**
 * The state of the auth module
 */
export interface IConfigurationReducer {
  staticMenu: boolean;
  apiEndpoint: string;
}

export type IReducerPayload = IConfiguration | null;
